export default __webpack_public_path__ + "static/media/06.784f9c49.webp";